import { z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';
import { UuidSchema } from '../../common/id/id';
import { NotificationChannelSchema } from '../notification-channel/notification-channel';
import {
  NotificationDeliveryStatusSchema,
  NotificationFailureReasonSchema,
} from '../notification-delivery/notification-delivery';

/**
 * The staff delivery log (N7).
 *
 * Offset-paginated, unlike the member's own list: this is an admin table over
 * data the reader is not writing to, which is exactly the case offsets are right
 * for (`cursor-page.ts` §"why this exists beside pagination").
 *
 * `status` is a plain enum filter rather than a `deadOnly` boolean, because the
 * dead-letter view is one value of it and an operator chasing an outage wants
 * `failed` and `sending` too — a boolean would have needed a second filter
 * within a week.
 */
export const NotificationDeliveriesListQuerySchema = makeListQuery({
  status: NotificationDeliveryStatusSchema.optional(),
  channel: NotificationChannelSchema.optional(),
  failureReason: NotificationFailureReasonSchema.optional(),
  userId: UuidSchema.optional(),
  /**
   * Everything one campaign sent. How the campaign detail draws its own log
   * without a second table (P21c) — the filter is added here, once, rather than
   * by giving campaigns a delivery list of their own.
   */
  campaignId: UuidSchema.optional(),
  /** Matches the template key — the one string a staff member can quote from a row. */
  search: z.string().trim().min(1).max(120).optional(),
});

export type NotificationDeliveriesListQuery = z.infer<typeof NotificationDeliveriesListQuerySchema>;
